import axios from 'axios';

export async function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post('/api/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data.url;
} 